import { createReducers, createActions, request } from '../../../utils/';
import { combineReducers } from 'redux';
import Urls from '../../../../config/index';
import { message } from 'antd';
import _ from 'lodash';
import moment from 'moment';
const { clientUrl } = Urls;

const path = name => `app/pages/commendList/${name}`;
let listOfTranker;
const models = {
    list: {
        data: [],
        handlers: {
            get(state, action) {
                return action.payload;
            },
            add(state, action) {
                return [...action.payload, ...state];
            },
            del(state, action) {
                return state.filter(item => item._id !== action.payload);
            },
            update(state, action) {
                return state.map(item => (item._id === action.payload._id ? action.payload : item));
            },
        },
    },
    listClient: {
            data: [],
            handlers: {
                get(state, action) {
                    return action.payload;
                },
                add(state, action) {
                    return [...action.payload, ...state];
                },
                del(state, action) {
                    return state.filter(item => item._id !== action.payload);
                },
                update(state, action) {
                    return state.map(item => (item._id === action.payload._id ? action.payload : item));
                },
            },
        },
    listAll: {
        data: [],
        handlers: {
            getAll(state, action) {
                return action.payload;
            },
        },
    },

    valueInput: {
        data: '',
        handlers: {
            setValueInput(state, action) {
                return action.payload;
            },
        },
    },
    commandStatus: {
        data: -1,
        handlers: {
            setCommandStatus(state, action) {
                return action.payload;
            },
        },
    },
    message: {
        data: '',
        handlers: {
            setMessage(state, action) {
                return action.payload;
            },
        },
    },
    transferData: {
        data: {
            selectedRowKeys: [],
        },
        handlers: {
            getTransferData(state, action) {
                return {...state, ...action.payload};
            },
        },
    },
    transferDataCopy: {
        data: {
            selectedRowKeys1: [],
        },
        handlers: {
            getTransferDataCopy(state, action) {
                return {...state, ...action.payload};
            },
        },
    },
    pagination: {
        data: {
            current: 1,
            total: 0,
            pageSize: 20,
        },
        handlers: {
            changePagination(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    searchValues: {
        data: {},
        handlers: {
            changeSearchValues(state, action) {
                return action.payload;
            },
        },
    },
    listAllChild: {
        data: [],
        handlers: {
            getlistAllChild(state, action) {
                return action.payload;
            },
        },
    },
    uiStatus: {
        data: {
            isLoading: false,
            isUpdateShow: false,
            isSendCommend: false,
            resultShowStatus: false,
            isOrderLoading:false,
            delAllCommandStatus:false,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    currentSelectId: {
        data: '',
        handlers: {
            changeCurrentSelectId(state, action) {
                return action.payload;
            },
        },
    },
};

export const actions = createActions(models, path);

export default combineReducers(createReducers(models, path));

const formatGetParams = getState => {
    const state = getState().commendList;
    const searchValue = state.searchValues || {};

    const params = {
        ...searchValue,
        page: state.pagination.current,
        pageSize: state.pagination.pageSize,
    };
    return params;
};

export const changeTrankerSource = (onLineC,osC) => {
    return async (dispatch, getState) => {

        if (!onLineC && !osC) {
            dispatch(actions.getlistAllChild(listOfTranker));
            return;
        }

        let listall = listOfTranker;
        let listAllChild = new Array();
        for (let i = 0; i < listall.length; i++) {
            let flag1 = 0;
            let flag2 =0 ;
            let child = listall[i];
            if ((!onLineC || onLineC=="-1") || child.onLine == onLineC) {
                flag1 = 1;
            }
            if ((!osC || osC=="-1") || child.os == osC) {
                flag2 = 1;
            }
            if (flag1 == 1&&flag2 == 1) {

                listAllChild.push(listall[i]);
            }
        }
        dispatch(actions.getlistAllChild(listAllChild));
    };
};


/**
 * 获取订单列表数据
 */
export const asyncGet = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(clientUrl.getcommandOrderList, 'POST', formatGetParams(getState));
            let { list } = result;
            list = list.map(item => {
                item.key = item.clientId;
                return item;
            });
            dispatch(actions.get(list));
            dispatch(actions.changePagination({total: result.total}));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};


// 重启
export const reStart = params => {
    return async (dispatch, getState) => {
        try {
            await request(clientUrl.commendModify, 'POST', params);
            message.success('操作成功');
        } catch (e) {
            throw new Error(e);
        }
    };
};

// 删除所有命令
export const delAllCommand = params => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    delAllCommandStatus: true,
                }),
            );
            await request(clientUrl.dellAllCommand+"?type=1");
            message.success('删除成功');
        } catch (e) {
            message.error('删除失败!');
            throw new Error(e);
        }finally {
            dispatch(
                actions.changeUiStatus({
                    delAllCommandStatus: false,
                }),
            );
        }
    };
};





// WEBPACK FOOTER //
// ./pages/client/commendList/reducers.js